import { Select } from "@chakra-ui/react";
import {
	OrdersKanbanMaterialType,
	useOrdersKanbanStore,
} from "../../../stores/kanban.store";

const OrdersMaterialFilter = () => {
	const {
		filters: { material },
		setFilterMaterial,
	} = useOrdersKanbanStore();

	return (
		<Select
			name="material"
			value={material ?? ""}
			onChange={(e) => {
				e.preventDefault();
				e.stopPropagation();
				setFilterMaterial(e.target.value as OrdersKanbanMaterialType);
			}}
			placeholder="Matériau"
		>
			<option value="SILICONE">Silicone</option>
			<option value="RESIN">Résine</option>
		</Select>
	);
};

export default OrdersMaterialFilter;
